import type { Dispatch, SetStateAction } from 'react';
import type { AddItemVisibility } from 'src/components/add-item/types';
import { Text } from '@savvy-kit/foundations/text';
import { CircleCheck } from 'lucide-react';

import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';
import { successColors } from '@savvy/deprecated-shared/theme';

import TrackedButton from '../../tracked/tracked-button';

function ConnectAccountPreview({
  setShowAddItemDialog,
}: {
  readonly setShowAddItemDialog: Dispatch<SetStateAction<AddItemVisibility | undefined>>;
}) {
  const { user } = useAuth();

  const userRoleBasedTip =
    user?.role === 'NON_ADVISORY_USER' ? (
      <div className="flex flex-row gap-2">
        <CircleCheck color={successColors.main} style={{ marginTop: 8 }} />
        <Text>Get matched with an advisor to help you meet your financial goals.</Text>
      </div>
    ) : (
      <div className="flex flex-row gap-2">
        <CircleCheck color={successColors.main} style={{ marginTop: 8 }} />
        <Text>Your advisor has visibility so they can make the best recommendations to meet your goals.</Text>
      </div>
    );

  return (
    <div
      data-testid="connect-account-banner"
      className="mt-8 pt-8 pl-8 rounded-lg border border-border-light max-h-[1104px]"
    >
      <div className="flex flex-row justify-between -mb-6 -mr-3">
        <div className="mb-13">
          <Text variant="h4" color="dark">
            All your wealth in one place
          </Text>
          <div className="flex flex-col gap-6 mt-10 mx-auto pb-10 w-[510px]">
            <div className="flex flex-row gap-2">
              <CircleCheck color={successColors.main} style={{ marginTop: 8 }} />
              <Text>One app for all of your investment accounts, bank accounts, and any other type of asset.</Text>
            </div>
            {userRoleBasedTip}
          </div>
          <TrackedButton
            elementName="connect-account-preview-connect-account-button"
            type="submit"
            className="mt-2"
            onClick={() => {
              setShowAddItemDialog('VISIBLE');
            }}
          >
            Connect an account
          </TrackedButton>
        </div>
        <div>
          {/* eslint-disable-next-line @next/next/no-img-element -- preview asset is a fixed Cloudinary marketing image */}
          <img
            height="346"
            width="519"
            src="https://res.cloudinary.com/hbb0rvydd/image/upload/v1695326471/Frame_462_pdgs9l.png"
          />
        </div>
      </div>
    </div>
  );
}

export default ConnectAccountPreview;
